"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _spinner = require("@flomni/components/dist/components/spinner");

var _useStyles = _interopRequireDefault(require("../../../helpers/useStyles"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _reactTransitionGroup = require("react-transition-group");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles["default"])(".caab9e893{position:absolute;width:100%;height:100%;top:0;left:0;display:flex;justify-content:center;align-items:center;z-index:9999;opacity:0;transition:opacity var(--animation-timing-def) ease}.ce027f589{opacity:1}.cd52c2e1b{width:100%;height:100%;background-color:#03256b;opacity:.4}.cd52c2e1b:not(.c919ba01c){border-radius:var(--border-radius-def)}.c9c4c0bd1{position:absolute;width:5rem;height:5rem}");
var styles = {
  loader: 'caab9e893',
  'loader-opened': 'ce027f589',
  background: 'cd52c2e1b',
  global: 'c919ba01c',
  spinner: 'c9c4c0bd1'
};

var EmbeddedLoader = function EmbeddedLoader(props) {
  var css = (0, _useStyles["default"])(styles);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isShow = _useState2[0],
      setIsShow = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsShow(props.show);
  }, [props.show]);
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    unmountOnExit: true,
    exit: false,
    "in": isShow,
    timeout: 200,
    classNames: {
      enterDone: css('loader-opened')
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: css('loader')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: css(['background', props.global ? 'global' : null])
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: css('spinner')
  }, /*#__PURE__*/_react["default"].createElement(_spinner.Spinner, {
    view: "light"
  }))));
};

EmbeddedLoader.propTypes = {
  show: _propTypes.bool.isRequired,
  global: _propTypes.bool
};

var _default = /*#__PURE__*/(0, _react.memo)(EmbeddedLoader);

exports["default"] = _default;